import { ReactNode, useEffect } from "react";
import { Link } from "react-router-dom";
import { HoneConnectLogo, LadyLookingAtPhone } from "../../../assets/img";
import { SITELINKS } from "../../../app-routes/links";

type LayoutProps = { children?: ReactNode; title?: string };

const APP_VERSION = process.env.REACT_APP_VERSION;

const AuthLayout = ({ children, title = "HoneConnect Admin" }: LayoutProps) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  const year = new Date().getFullYear();

  return (
    <main className="min-h-screen bg-white font-poppins lg:grid lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)] xl:grid-cols-2">
      {/* Image panel: banner on mobile/tablet, full-height side panel on desktop */}
      <aside className="relative h-52 sm:h-72 lg:sticky lg:top-0 lg:h-screen lg:p-4">
        <div className="relative h-full w-full overflow-hidden lg:rounded-[28px]">
          <img
            src={LadyLookingAtPhone}
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_40%] lg:object-[50%_18%]"
          />
          <div
            aria-hidden
            className="absolute inset-0 bg-gradient-to-t from-hc_59077A/90 via-hc_59077A/25 to-transparent"
          />
          <div className="absolute inset-x-0 bottom-0 hidden p-10 text-white lg:block xl:p-12">
            <p className="flex items-center gap-2 text-sm font-medium text-white/80">
              <span aria-hidden className="h-2.5 w-2.5 rounded-full bg-hc_F3A838" />
              HoneConnect Admin
            </p>
            <p className="mt-4 max-w-md text-3xl font-semibold leading-snug xl:text-[2.125rem]">
              Users, requests and broadcasts, managed from one console.
            </p>
          </div>
        </div>
      </aside>

      {/* Form panel */}
      <section className="relative -mt-6 flex min-h-[calc(100vh-7.5rem)] flex-col rounded-t-[28px] bg-white px-6 sm:-mt-8 sm:min-h-[calc(100vh-16rem)] sm:px-10 lg:mt-0 lg:min-h-screen lg:rounded-none lg:px-16 xl:px-24">
        <header className="mx-auto w-full max-w-[420px] pt-8 lg:pt-10">
          <Link
            to={SITELINKS.SIGNIN}
            className="inline-block rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-honeConnectPurple/40"
          >
            <img
              src={HoneConnectLogo}
              alt="HoneConnect"
              className="-ml-1 h-11 w-auto sm:h-12 lg:-ml-[5px] lg:h-14"
            />
          </Link>
        </header>

        <div className="flex flex-1 items-center py-10 lg:py-12">
          <div className="mx-auto w-full max-w-[420px]">{children}</div>
        </div>

        <footer className="flex flex-col gap-1 border-t border-gray-100 py-6 text-xs text-gray-500 sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; {year} HoneConnect. All rights reserved.</p>
          {APP_VERSION && <p>Version {APP_VERSION}</p>}
        </footer>
      </section>
    </main>
  );
};

export default AuthLayout;
